// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';

import styles from './styles';


class Books extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    books: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    books: [],
  };

  renderVoucher = (book) => {
    const { classes } = this.props;

    return (
      <div key={uuidv4()} className={classes.row}>
        {/* Books we hold no catalogue entry for have a null Title, which a
            template literal would print as the word "null". Historic 50p
            welcome-offer lines are the usual case - bookshops no longer get
            that offer, but their existing vouchers still carry those rows. */}
        <p className={classes.text}>{book.Title || 'Title unavailable'}</p>
        <p className={classes.text}>{`£${parseFloat(book.SellbackPrice).toFixed(2)}`}</p>
      </div>
    );
  }

  render() {
    const {
      classes,
      books,
    } = this.props;

    const headers = ['title', 'price'];

    return (
      <div>
        <div className={classes.row}>
          {headers.map(header => (
            <p key={uuidv4()} className={classes.headerText}>
              {`${header}`}
            </p>
          ))}
        </div>
        <div>
          {Array.from(books).map(book => this.renderVoucher(book))}
        </div>
      </div>
    );
  }
}

export default (withStyles(styles)(Books));
